'use strict';

const fillAddressFields = require('../../modules/util/fillAddressFields');

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
exports.init = function (formInit) {
    let form = formInit;
    if (!form || form.length == 0) {
        form = $('.js-checkout-form');
    }
    // select address from list
    $('select[name$="_addressList"]', form).off('change').on('change', function () {
        const selected = $(this).children(':selected').first();
        const selectedAddress = $(selected).data('address');
        if (!selectedAddress) { return; }
        fillAddressFields(selectedAddress, form);

        $('input[name$=_singleshipping_shippingAddress_addressFields_postal]', form).trigger('input.postalerror');

        // re-validate the form
        form.validate().form();
    });
};
